import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Bio } from './components/Bio'
import { SelectedWork } from './components/SelectedWork'
import { Awards } from './components/Awards'
import { Media } from './components/Media'
import { Career } from './components/Career'
import { WorkDetail } from './components/WorkDetail'
import { Stack } from './components/Stack'
import { Links } from './components/Links'
import { Footer } from './components/Footer'
import { Cat } from './components/Cat'

const App = () => {
  return (
    <div className="min-h-dvh flex flex-col">
      <a href="#main-content" className="skip-link">
        コンテンツへスキップ
      </a>
      <Header />
      <main
        id="main-content"
        className="flex-1 mx-auto w-full max-w-2xl px-6 sm:px-8 py-12 sm:py-20"
      >
        <Hero />
        <Bio />
        <SelectedWork />
        <Awards />
        <Media />
        <Career />
        <WorkDetail />
        <Stack />
        <Links />
      </main>
      <Footer />
      <Cat />
    </div>
  )
}

export default App
